module.exports = __webpack_public_path__ + "static/media/icon-merchant.9d456177.svg";